import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import api from "../../../api";

const CourseWiseReports = ({ uid }) => {
  
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // For academic years
  const [selectedYear, setSelectedYear] = useState("");
  const [userdata, setUserData] = useState([]); // For course data

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/users/getacademicyear/${uid}`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching academic years:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid]);

  useEffect(() => {
    if (!selectedYear) return;

    const fetchCourses = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/getusercoursebybranch/${uid}`, {
          params: { selectedYear },
        });
        setUserData(res.data);
      } catch (err) {
        console.error("Error fetching course data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [selectedYear, uid]);

  // Group data by semester and sort courses by coursecode
  const groupedData = userdata.reduce((acc, course) => {
    if (!acc[course.semester]) {
      acc[course.semester] = [];
    }
    acc[course.semester].push(course);
    acc[course.semester].sort((a, b) => a.coursecode.localeCompare(b.coursecode));
    return acc;
  }, {});

  const handleCourseClick = (course) => {
    navigate("/courseresultreports", {
      state: {
        usercourseid: course.usercourse_id,
        coursecode: course.coursecode,
        coursename: course.course_name,
        academicYear: selectedYear,
        semester: course.semester,
        teacher_name:course.teacher_name
      },
    });
  };

  return (
    <div>
      <div className="w-full mt-8">
        <h1 className="text-2xl font-bold mb-6 text-center">
          Course Wise Reports
        </h1>

        {loading ? (
          <p className="text-blue-500 text-center">Loading...</p>
        ) : (
          <div className="w-full max-w-md mx-auto mb-8">
            <label
              htmlFor="academicYear"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Select Academic Year:
            </label>
            <select
              id="academicYear"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="block w-full p-2.5 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>
                -- Select Academic Year --
              </option>
              {data.map((item, index) => (
                <option key={index} value={item.academic_year}>
                  {item.academic_year}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Display Semester-wise Grouped Courses */}
        {Object.keys(groupedData).length > 0 ? (
          Object.keys(groupedData).map((semester) => (
            <div key={semester} className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Semester {semester}
              </h2>
              <div className="overflow-x-auto">
                <table className="table-auto w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 p-2 text-left">
                        Course Code
                      </th>
                      <th className="border border-gray-300 p-2 text-left">
                        Course Name
                      </th>
                      <th className="border border-gray-300 p-2 text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupedData[semester].map((course, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-50 cursor-pointer"
                        onClick={() => handleCourseClick(course)}
                      >
                        <td className="border border-gray-300 p-2">
                          {course.coursecode}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {course.course_name}
                        </td>
                        <td className="border border-gray-300 p-2 text-center">
                          <button
                            className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCourseClick(course);
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500 mt-4">
            No courses available for the selected academic year.
          </p>
        )}
      </div>
    </div>
  );
};

export default CourseWiseReports;
